import { useEffect, useState } from 'react'
import { useDiscoverEntityEntityType } from './useDiscoverEntityEntityType'
import {
  getAvailableFilters,
  simplifyFilters
} from '../screens/EntityListScreen'

/**
 * Hook to manage server filter state based on entity type configuration
 * @param {string|string[]} sourceName - Entity type name(s) to discover
 * @param {object} initialServerFilter - Initial server filter from field params
 * @returns {object} { entityType, serverFilter }
 */
export const useServerFilter = (sourceName, initialServerFilter) => {
  const { entityType } = useDiscoverEntityEntityType(
    null,
    null,
    sourceName,
    null,
    false
  )

  const [serverFilter, setServerFilter] = useState(initialServerFilter)

  useEffect(() => {
    const availableFilters = getAvailableFilters(entityType)
    const newServerFilter = entityType?.object_data?.filters_selected
      ? simplifyFilters(
          {},
          entityType?.object_data?.filters_selected,
          availableFilters
        )
      : initialServerFilter

    setServerFilter(newServerFilter)
  }, [entityType, initialServerFilter])

  return { entityType, serverFilter }
}
